export const JOB_LIST = [
  {
    title: "Sales and Marketing Intern",
    description:
      "Offering a Sales and Marketing Internship for eager individuals to kickstart their careers.",
    workMode: "Hybrid",
    location: "Indore",
    jobType: "Full time",
  },
  {
    title: "Sales & Marketing Executive",
    description:
      "Seeking a motivated Sales and Marketing Executive with 0-2 years of experience to join our team.",
    workMode: "Hybrid",
    location: "Indore",
    jobType: "Full time",
  },
  {
    title: "Accounts and Finance Executive",
    description:
      "Seeking a detail-oriented Accounts and Finance Professional to manage our organization's financial health.",
    workMode: "Hybrid",
    location: "Indore",
    jobType: "Full time",
  },
  {
    title: "Digital Marketing Trainee",
    description:
      "Entry-level role for those passionate about digital marketing and eager to learn SEO, social media, and email campaigns.",
    workMode: "Hybrid",
    jobType: "Full time",
    location: "Indore",
  },
  {
    title: "Field Sales Officer",
    description:
      "We are seeking a motivated and dynamic Field Sales Officer to drive sales and expand our customer base.",
    workMode: "Hybrid",
    jobType: "Full time",
    location: "Indore",
  },
  {
    title: "Delivery Incharge",
    description:
      "We are looking for a reliable and detail-oriented Delivery Incharge to oversee and manage the delivery operations efficiently.",
    workMode: "Hybrid",
    jobType: "Full time",
    location: "Indore",
  },
];

export const ALL_DETAIL_ROUTES_INFO = [...JOB_LIST];
